import { combineLatest } from 'rxjs';
import {
  distinctUntilChanged,
  map,
  shareReplay,
  startWith,
} from 'rxjs/operators';
import { ScenarioModeState } from '@ardoq/data-model';
import { activeScenario$ } from 'streams/activeScenario/activeScenario$';
import { scenarios$, ScenariosState } from 'streams/scenarios/scenarios$';
import { MASTER_ID } from 'sync/ardoqEventOperations';

export const toActiveBranchId = (
  { scenarioId }: ScenarioModeState,
  scenarios: ScenariosState
): string => (scenarioId && scenarios.byId[scenarioId]?.branchId) || MASTER_ID;

export const activeBranchId$ = combineLatest([
  activeScenario$,
  scenarios$,
]).pipe(
  map(([activeScenario, scenarios]) =>
    toActiveBranchId(activeScenario, scenarios)
  ),
  startWith(MASTER_ID),
  distinctUntilChanged(),
  shareReplay({ bufferSize: 1, refCount: true })
);
